import { Directive, ElementRef, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[appAutoFocus]',
})
export class AutoFocusDirective implements AfterViewInit {
  constructor(readonly el: ElementRef) {}

  ngAfterViewInit() {
     Promise.resolve().then(() => this.el.nativeElement.focus());
  }
}
